import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    img_domain: 'https://tools.linqode.com/tools/assets/hmgc/images/',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
